import { FormElementModel } from "../../../models/FormElementModel";
import { emailValidator, passValidator, phoneValidator, repeatPassValidator } from "../../../../utils/formsValidation";

export const userRegisterForm = (watch: any, register: any): FormElementModel[] => [
  {
    name: "firstName",
    type: "text",
    text: "Imię",
    isLabel: true,
    register: { ...register("firstName", { required: true }) },
  },
  {
    name: "lastName",
    type: "text",
    text: "Nazwisko",
    isLabel: true,
    register: { ...register("lastName", { required: true }) },
  },
  {
    name: "email",
    type: "text",
    text: "E-mail",
    isLabel: true,
    register: { ...register("email", { ...emailValidator(true) }) },
  },
  {
    name: "password",
    type: "password",
    text: "Hasło",
    isLabel: true,
    register: { ...register("password", { ...passValidator(true) }) },
  },
  {
    name: "repeatPassword",
    type: "password",
    text: "Powtórz hasło",
    isLabel: true,
    register: { ...register("repeatPassword", { ...repeatPassValidator(true, watch("password", "")) }) },
  },
  {
    name: "phone",
    type: "number",
    text: "Telefon kontaktowy",
    isLabel: true,
    register: { ...register("phone", { ...phoneValidator(true) }) },
  },
];
